import { ReactNode, SVGProps } from 'react';

export const VARIANT_DEFAULT = {
  textColor: 'text-primary',
  background: 'bg-surface-secondary',
};

export const VARIANT_DEFAULT_DARK = {
  textColor: 'text-primary',
  background: 'bg-tertiary',
};

export const VARIANT_INFO = {
  textColor: 'text-accent',
  background: 'bg-info',
};

export const VARIANT_WARNING = {
  textColor: 'text-warning',
  background: 'bg-warning',
};

export const VARIANT_CRITICAL = {
  textColor: 'text-critical',
  background: 'bg-critical',
};

export const VARIANT_SUCCESS = {
  textColor: 'text-success',
  background: 'bg-success',
};

export const DEFAULT = 'default';

export const DEFAULT_DARK = 'default-dark';

export const INFO = 'info';

export const WARNING = 'warning';

export const CRITICAL = 'critical';

export const SUCCESS = 'success';

export const VARIANTS = {
  [DEFAULT]: VARIANT_DEFAULT,
  [DEFAULT_DARK]: VARIANT_DEFAULT_DARK,
  [INFO]: VARIANT_INFO,
  [WARNING]: VARIANT_WARNING,
  [CRITICAL]: VARIANT_CRITICAL,
  [SUCCESS]: VARIANT_SUCCESS,
};

export type Variant =
  | typeof DEFAULT
  | typeof DEFAULT_DARK
  | typeof INFO
  | typeof WARNING
  | typeof CRITICAL
  | typeof SUCCESS;

interface IconProps {
  icon: (props: SVGProps<SVGSVGElement>) => JSX.Element;
  props?: SVGProps<SVGSVGElement>;
  width: string;
  height: string;
}

export interface CardDisclosureProps {
  isDefaultOpen?: boolean;
  isSticky?: boolean;
  handleChangeVisibility?: (isOpen: boolean) => void;
  showChevronIcon?: boolean;
  icon?: IconProps;
  titleText: string;
  descriptionText?: string | ReactNode;
  paddingDescription?: string;
  widthClassName?: string;
  marginClassNames?: string;
  disclosurePadding?: string;
  variant: Variant;
  /** Overrides the variant's background utility (e.g. 'fill-primary'). */
  backgroundClassName?: string;
}
